export const parseToSnakeCase = (value: string) => value?.split('-').join('_')
